<div class="card-preview" [class.has-pos-abs]="isAbsolutePosition" #cardPreviewRef [@previewTrigger]="state" appRmSwiper (onSwipe)="swipeTogglePreview($event)"
[stopPropagation]="false" [stopDefault]="false">
  <span class="close-ic has-pos-abs" (click)="hidePreview.emit()">
    <i style="font-weight: bold;" class="material-icons v-align">close</i>
  </span>

  <app-item-swiper [hasFinishedLoadingItems]="true" [showItemCount]="false" [isForCardPreview]="true" [items]="cards" (slideChanged)="slideChanged($event)"
  [selectedListingIndex]="selectedListingIndex" [initialItemIndex]="initialCardIndex" (itemClicked)="cardClicked.emit($event)" (itemFocused)="cardFocused.emit($event)">
    <ng-container *ngFor="let card of cards; let i = index; trackBy: trackBy" [ngTemplateOutlet]="cardContentTemplate" [ngTemplateOutletContext]="{ card: card, isSelectedCard: i === currentCardIndex, isNextCard: i === (currentCardIndex + 1) }">
    </ng-container>
  </app-item-swiper>

</div>
